export const QuestionTypes = [
    { code: 'Transcription', label: 'Transcription Question' },
    { code: 'YesNo', label: 'YesNo Questions'},
    { code: 'Annotation/multichoice', label: 'Annotation Multichoice Question' },
    { code: 'Translation/multichoice', label: 'Translation Multichoice Question' },
    { code: 'Translation/basic', label: 'Translation Basic Question' },
    { code: 'p-vocabulary', label: 'Vocabulary' },
    { code: 'reading-compherension', label: 'Reading Comprehension' },
    { code: 'critical-thinking', label: 'Critical Thinking' },
    { code: 'parallel-reasoning', label: 'Parallel Reasoning' },
    { code: 'paragraph-writing', label: 'Paragraph Writing' },
    { code: 'image-describing', label: 'Image Describing' },
    { code: 'paragraph-improvement', label: 'Paragraph Improvement' },
    { code: 'paragraph-summary', label: 'Paragraph Summary' },
    { code: 'Voice Collection Validator', label: 'Voice Collection Validator Question' },
];
